<ion-grid class="max-w-1336 content-box" style="margin-top: 40px" *ngIf="getb2bList$ | async as b2b">
	<ng-container *ngIf="b2b.isSkeleton">
		<ion-grid class="side-menu-wrapper text-center">
			<ion-spinner class="ion-spinner"></ion-spinner>
		</ion-grid>
	</ng-container>
	<ng-container *ngIf="!b2b.isSkeleton">
		<ion-row style="align-items: center">
			<ion-button (click)="createb2b()"><ion-icon name="add-outline"></ion-icon></ion-button>
			<p class="Heading_M">Add New B2B company</p>
		</ion-row>
		<ion-row>
			<ion-col class="grid-container">
				<ion-card color="light" *ngFor="let b2b of b2b.data" class="grid-item" (click)="viewB2B(b2b.shortcode)">
					<div class="b2bLogo">
						<img [src]="b2b.logo" alt="b2b-image" />
					</div>
					<div class="b2b-content">
						<ion-card-header>
							<ion-card-title>Name : {{b2b.name}}</ion-card-title>
						</ion-card-header>
						<ion-card-content>
							Shortcode : {{b2b.shortcode}}
							<ng-container *ngIf="b2b.onBoardingSkip">
								<br />
								On boarding Skip : {{b2b.onBoardingSkip}}
							</ng-container>
							<ng-container *ngIf="b2b.termCondition">
								<br />
								Terms & Condition : {{b2b.termCondition}}
							</ng-container>
						</ion-card-content>
						<ion-card-content class="actions" (click)="stop($event)">
							<p (click)="updateb2b(b2b,$event)" class="cursor">Edit</p>

							<p appConfirmBox (learnDelete)="deleteb2b(b2b.id)" title="Delete {{b2b.name}} (B2B) company"
								subTitle="Are you sure you want to delete {{b2b.name}} (B2B) company?"
								class="Body_S text-right cursor">
								Delete
							</p>
						</ion-card-content>
					</div>
				</ion-card>
			</ion-col>
		</ion-row>
	</ng-container>
</ion-grid>